import React, { useState, useEffect, useCallback } from 'react';
import { TransformWrapper, TransformComponent } from 'react-zoom-pan-pinch';
import { FaEye, FaComment, FaCode, FaBullseye, FaTasks, FaClock, FaExclamationTriangle, FaCheck } from 'react-icons/fa';
import { ReactComponent as HardwareDiagramSVG } from './assets/exampleproj1/exampleproj1_hardware.svg';
import { ReactComponent as CodeFunctionalitySVG } from './assets/exampleproj1/exampleproj1_software.svg';
import Nav from "../Nav";
import "../ProjectTemplate.css";

const ExampleProj1Page = () => {
  const [theme, setTheme] = useState(() => {
    const saved = localStorage.getItem("theme");
    return saved || "dark";
  });

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
    localStorage.setItem("theme", theme);
  }, [theme]);

  const [showModal, setShowModal] = useState(false);
  const [modalContent, setModalContent] = useState(null);

  const openModal = useCallback((content) => {
    setModalContent(content);
    setShowModal(true);
  }, []);

  const closeModal = useCallback(() => {
    setShowModal(false);
    setModalContent(null);
  }, []);

  useEffect(() => {
    const handler = (e) => {
      if (e.key === "Escape") closeModal();
    };
    if (showModal) {
      document.addEventListener("keydown", handler);
      document.body.classList.add("modal-open");
    }
    return () => {
      document.removeEventListener("keydown", handler);
      document.body.classList.remove("modal-open");
    };
  }, [showModal, closeModal]);

  return (
    <div className="app">
      <Nav theme={theme} setTheme={setTheme} />
      <div className="project-wrap">
        <div className="project-hero-card">
          <h1>Example Project 1</h1>
          <p className="project-subtitle">Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
          <p className="project-blurb">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
          </p>
        </div>

        <div className="project-section">
          <div className="project-section-head">
            <h2>Project Overview</h2>
            <p>Lorem ipsum dolor sit amet consectetur.</p>
          </div>
          <div className="project-card-full">
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
            </p>
            <p>
              Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
            </p>
          </div>
        </div>

        <div className="project-section">
          <div className="project-section-head">
            <h2>Core Tracking Systems</h2>
            <p>Lorem ipsum dolor sit amet consectetur.</p>
          </div>
          <div className="project-grid">
            <div className="project-card">
              <h3><FaEye /> Feature One</h3>
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
              </p>
            </div>
            <div className="project-card">
              <h3><FaCode /> Feature Two</h3>
              <p>
                Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
              </p>
            </div>
            <div className="project-card">
              <h3><FaComment /> Feature Three</h3>
              <p>
                Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.
              </p>
            </div>
          </div>
        </div>

        <div className="project-section">
          <div className="project-section-head">
            <h2>Voice System</h2>
            <p>Lorem ipsum dolor sit amet.</p>
          </div>
          <div className="project-card-full">
            <p>
              Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium.
            </p>
            <p>
              Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt.
            </p>
          </div>
        </div>

        <div className="project-section">
          <div className="project-section-head">
            <h2>System Capabilities</h2>
            <p>Lorem ipsum dolor sit amet.</p>
          </div>
          <div className="project-two-col">
            <div className="col">
              <p>
                At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident.
              </p>
            </div>
            <div className="col col-highlight">
              <h3 style={{ fontSize: 16, fontWeight: 700, margin: "0 0 10px" }}>Feature List</h3>
              <ul className="project-list">
                <li><span>Feature One</span><FaCheck style={{color: "var(--brand)"}} /></li>
                <li><span>Feature Two</span><FaCheck style={{color: "var(--brand)"}} /></li>
                <li><span>Feature Three</span><FaCheck style={{color: "var(--brand)"}} /></li>
                <li><span>Feature Four</span><FaCheck style={{color: "var(--brand)"}} /></li>
              </ul>
            </div>
          </div>
        </div>

        <div className="project-section">
          <div className="project-section-head">
            <h2>Advanced Features</h2>
            <p>Lorem ipsum dolor sit amet.</p>
          </div>
          <div className="project-grid-2">
            <div className="project-card">
              <h3><FaBullseye /> Feature Alpha</h3>
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation.
              </p>
            </div>
            <div className="project-card">
              <h3><FaTasks /> Feature Beta</h3>
              <p>
                Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident.
              </p>
            </div>
            <div className="project-card">
              <h3><FaClock /> Feature Gamma</h3>
              <p>
                Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo.
              </p>
            </div>
            <div className="project-card">
              <h3><FaExclamationTriangle /> Feature Delta</h3>
              <p>
                Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi.
              </p>
            </div>
          </div>
        </div>

        <div className="project-section">
          <div className="project-section-head">
            <h2>System Architecture</h2>
            <p>Lorem ipsum dolor sit amet consectetur.</p>
          </div>
          <div className="project-grid-2">
            <div className="project-card" onClick={() => openModal('hardware')}>
              <h3>Diagram A</h3>
              <div className="diagram-preview-wrapper">
                <HardwareDiagramSVG preserveAspectRatio="xMidYMid slice" />
              </div>
              <p style={{ fontSize: 13, color: "var(--text-muted)", textAlign: "center", marginTop: 10 }}>
                Click to expand diagram &bull; Pan &amp; Zoom to explore
              </p>
            </div>
            <div className="project-card" onClick={() => openModal('code')}>
              <h3>Diagram B</h3>
              <div className="diagram-preview-wrapper">
                <CodeFunctionalitySVG preserveAspectRatio="xMidYMid slice" />
              </div>
              <p style={{ fontSize: 13, color: "var(--text-muted)", textAlign: "center", marginTop: 10 }}>
                Click to expand diagram &bull; Pan &amp; Zoom to explore
              </p>
            </div>
          </div>
        </div>
      </div>

      {showModal && (
        <div className="project-modal-overlay" onClick={closeModal}>
          <div className="project-modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="close-button" onClick={closeModal}>&times;</button>
            <div className="modal-svg-wrapper">
              <TransformWrapper
                initialScale={1}
                minScale={0.1}
                maxScale={5}
                centerOnInit={true}
                wheel={{ smoothStep: 0.0025, activationKeys: ["Control", "Meta"] }}
                limitToBounds={false}
                centerZoomedOut={false}
              >
                <TransformComponent
                  wrapperStyle={{ width: "100%", height: "100%" }}
                  contentStyle={{ width: "100%", height: "100%" }}
                >
                  {modalContent === 'hardware'
                    ? <HardwareDiagramSVG preserveAspectRatio="xMidYMid slice" />
                    : <CodeFunctionalitySVG preserveAspectRatio="xMidYMid slice" />
                  }
                </TransformComponent>
              </TransformWrapper>
            </div>
          </div>
        </div>
      )}

      <footer className="project-footer">
        <p>&copy; {new Date().getFullYear()} Nameless</p>
        <a href="#" onClick={(e) => e.preventDefault()}>email@example.com</a>
      </footer>
    </div>
  );
};

export default ExampleProj1Page;
